<template>
  <div class="state-card text-center py-5">
    <div class="empty-icon mx-auto mb-3">
      <i :class="icon"></i>
    </div>
    <p class="empty-title mb-1">{{ title }}</p>
    <p v-if="description" class="text-muted small mb-0">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "EmptyList",
  props: {
    icon: { type: String, default: "fas fa-inbox" },
    title: { type: String, required: true },
    description: { type: String, default: "" },
  },
};
</script>

<style scoped>
.state-card {
  background: #ffffff;
  border: 1px solid #e5e9f2;
  border-radius: 16px;
}

.empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: #eef2ff;
  color: #4f46e5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}

.empty-title {
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
}
</style>
